// extracted by mini-css-extract-plugin
export default {"root":"IconNote_root__Ydroo"};